<template>
  <div class="select-color">
    <el-popover popper-class="personal-title-edit" placement="bottom" trigger="click" v-model="show" :disabled="disabled">
      <div class="list">
        <i class="el-icon-loading" v-if="colorList.length === 0"></i>
        <div class="list-item" :class="{'check':item.id === currentValue}" v-for="(item) in colorList" :key="item.id" @click.stop="selectColor(item)">
          <span :style="{'background':item.color_number}"></span>
        </div>
        <div class="clear-box" @click="clearColor">
          <span><i class="icon iconfont iconicon_sign_cancel"></i></span>
        </div>
      </div>
      <div class="btn-box" :class="{'btn-box-disabled':disabled}" slot="reference">
        <slot>
          <p v-if="checkItem.id">
            <span class="select-round" :style="{'background':checkItem.color_number}"></span>
            <span>{{checkItem.color_name}}</span>
          </p>
          <p v-else-if="!disabled">
            <i class="icon iconfont iconicon_sign"></i>
            <span>添加标记</span>
          </p>
        </slot>
      </div>
    </el-popover>
  </div>
</template>
<script>
import api from '@/services/api/mine/mine'
export default {
  props: ['value', 'disabled'],
  data() {
    return {
      show: false,
      colorList: [],
      colorLoading: false,
      checkItem: {},
    }
  },
  watch: {
    show(val) {
      if (val) {
        if (this.colorList.length > 0) return
        this.colorLoading = true
        api.getColorList({}).then(res => {
          this.colorList = res
          this.colorLoading = false
        })
      }
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined
      },
      set: function (newValue) {
        this.$emit('input', newValue || '')
        this.$emit('change', this.checkItem)
      }
    }
  },
  methods: {
    selectColor(item) {
      if (item.id === this.currentValue) return
      this.checkItem = item
      this.currentValue = item.id
      this.show = false
    },
    clearColor() {
      this.checkItem = {}
      this.currentValue = ''
      this.show = false
    },
  }
}
</script>
<style lang="scss">
.personal-title-edit {
  .list {
    display: flex;
    height: 66px;
    align-items: center;
    padding: 0 13px;
    box-sizing: border-box;
    justify-content: space-between;
    width: 354px;
    .el-icon-loading {
      margin: 0 12px;
    }
    .list-item {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      user-select: none;
      width: 24px;
      height: 24px;
      padding: 3px;
      user-select: none;
      font-family: "iconfont";
      box-sizing: border-box;
      margin: 0 12px;
      &:hover {
        padding: 0;
      }
      span {
        border-radius: 50%;
        color: #fff;
        box-sizing: border-box;
        cursor: pointer;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          &::after {
            content: "\e7c0";
            line-height: 1;
            font-size: 16px;
          }
        }
      }
    }
    .check {
      span {
        &::after {
          content: "\e7a7" !important;
          line-height: 1;
          font-size: 16px;
        }
      }
      padding: 0;
    }
  }
  .clear-box {
    cursor: pointer;
    margin: 0 12px;
    i {
      color: #c3c6cb;
    }
  }
}
.select-color {
  .btn-box {
    height: 32px;
    border-radius: 4px;
    border: 1px solid rgba(32, 32, 32, 0.16);
    line-height: 32px;
    padding: 0 8px;
    display: inline-block;
    box-sizing: border-box;
    margin-right: 16px;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    color: rgba(32, 32, 32, 0.6);
    position: relative;
    .icon {
      font-size: 14px;
      margin-right: 10px;
    }
    p {
      display: flex;
      align-items: center;
    }
    // &:hover {
    //   background-color: #f7f8f9;
    // }
    // &:active {
    //   background-color: #eaebec;
    // }
  }
  .select-round {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
  }
  .btn-box-disabled {
    cursor: auto;
    &:hover {
      background: inherit;
    }
    &:active {
      background: inherit;
    }
  }
}
</style>
